// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1973":"774e5f1c8127f0cb","8007":"e3cd15611197c1f6"}[chunkId] + ".js";
};